<div [class]="`${containerClass}`" [ngClass]="{ card: showCardSpace }">
  @if(showCardHeader && showCardSpace){
  <div class="card-header border-0 pt-3 px-6">
    <h3 class="card-title align-items-center flex-dataColumns my-0">
      <span class="card-label fw-bolder fs-3 mb-1">{{
        tableLabel | translate
        }}</span>
    </h3>
    <div class="card-toolbar my-0">
      <button type="button" class="btn btn-sm btn-primary d-flex flex-row align-items-center fs-6" (click)="onClick()">
        <app-keenicon name="plus" class="text-white fs-3 me-1"></app-keenicon>

        {{ buttonLabel | translate }}
      </button>
    </div>
  </div>
  }

  <div class="mh-table-custom d-flex flex-column justify-content-between" [ngClass]="{
      'pt-6': !showCardHeader,
      'pe-3': vertical_scrollbar,
      'pe-6': !vertical_scrollbar && showCardSpace,
      'card-body card-body px-6 py-3 pb-5': showCardSpace
    }">
    <div id="widget-table" class="table-responsive h-table-body">
      @if(loading){
      <div class="col-12 loading-fixed">
        <app-progress-loading [isLoading]="loading"></app-progress-loading>
      </div>
      }
      <table class="table align-middle gs-0 gy-4 mb-0">
        <thead id="table_header">
          <tr class="fw-bolder text-gray-600 bg-gray-200 position-sticky">
            @for (header of dataColumns ; track header.prop; let column_index =
            $index) {
            <th [ngClass]="{
                'ps-4 rounded-start': column_index < 1,
                '': 0 < column_index && column_index > dataColumns.length - 1,
                'rounded-end pe-4': column_index === dataColumns.length - 1
              }" class="{{ header.headerClass }}">
              {{ header.name | translate }}
            </th>
            }
          </tr>
        </thead>
        <tbody>
          <!-- Not every source has an `id`: the study-record activity rows come
               out of a join and carry none, so all four tracked as the same
               empty key and Angular logged NG0955 twice per load. -->
          @if(sources?.data?.length){ @for (row of sources?.data; track row.id ?? row_index;
          let row_index = $index) {
          <tr [ngClass]="{
              'bg-hover-gray-100': showHoverBg,
              'cursor-pointer': rowClick
            }" [id]="'row_' + (row_index + 1)" (click)="clickedRow($event,row)">
            @for (header of dataColumns; track header.prop; let column_index =
            $index) {
            <td [ngClass]="{
                'ps-4 rounded-start': column_index < 1,
                '': 0 < column_index && column_index > dataColumns.length - 1,
                'rounded-end pe-4': column_index === dataColumns.length - 1,
                'border-bottom ': rowBorderBottom,
                'no-click cursor-unset': !header.clickable
              }" class="fw-bold mb-1 fs-6 mt-4">
              <div class="d-flex align-items-center  {{ header.cellClass }}">
                <div class="d-flex flex-column fw-semibolder fs-6">
                  <h6 class="mb-0 {{ header.propClass }}
                    {{
                      mapConditionClass(
                        row[objectKeyValue(header.prop)],
                        header.statusCell === true
                          ? header.statusClassCondition!
                          : []
                      )?.class
                    }}      
              ">
                    @if(header.currency){
                    <!-- The same money format the catalogue, the cart and the
                         order detail all use. This table printed "690 บาท"
                         beside pages showing "฿690.00" for the same amount. -->
                    {{ +row[objectKeyValue(header.prop)] | currency : "฿" }}
                    }@else {
                    @if(!header.cellTemplate){

                    {{ row[objectKeyValue(header.prop)] }}
                    }@else {
                    <ng-container *ngTemplateOutlet="header.cellTemplate; context: { $implicit: row }"></ng-container>

                    }
                    }
                  </h6>
                  <span class="fw-bold d-block fs-7" [ngClass]="
                      !header.subPropClass
                        ? 'text-muted'
                        : !isArray(header.subPropClass)
                        ? header.subPropClass
                        : header.statuses && isArray(header.statuses)
                        ? header.subPropClass![
                            statusIndex(column_index, row.status_id)!
                          ]
                        : 'text-muted'
                    ">
                    {{ row[objectKeyValue(header.sub_prop)] | translate }}
                  </span>
                </div>
              </div>
            </td>
            }
          </tr>
          } }@else{
          <tr class="text-center">
            <td [colSpan]="dataColumns.length">
              <ng-container *ngTemplateOutlet="noData"></ng-container>
            </td>
          </tr>

          }
        </tbody>
      </table>
    </div>
    @if(sources?.data?.length){
    <div class="pagination-fixed bg-white px-4">
      <app-paginations [dataSource]="sources" [isLoading]="loading"
        (onPageChange)="onTableChange($event)"></app-paginations>
    </div>
    }
  </div>
</div>

<ng-template #noData>
  <div class="d-flex justify-content-center align-items-center h-inherit text-gray-600 fw-normal fs-6 pt-2">
    {{ "TABLE.NO_DATA_DISPLAY" | translate }}
  </div>
</ng-template>